import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import {
  Button,
  withStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { styles } from "./Styles.css";
import { searchLatest, clearSelectedPreview } from "../redux/AllNewsActions";
import { Translation } from "react-i18next";
import Moment from "react-moment";
import { renderTextWithLinks, userDisplay } from "util/CommonFunc";
import UserDisplay from "util/UserDisplay";


class LatestNewsWrap extends Component {

  constructor(props) {
    super();
    this.state = {
      openPopup: false,
    };
  }

  componentDidMount() {
    const { searchLatest, allNews: { queryLatest } } = this.props;
    searchLatest(queryLatest);
  }

  componentDidUpdate(prevProps) {
    const { allNews: {
      latestLoading,
      latestItems,
      selectedPreviewItems,
      singleView,
    } } = this.props;
    if (prevProps.allNews.latestLoading && !latestLoading && (latestItems.length > 0 || selectedPreviewItems?.length > 0) && (localStorage.getItem("showNews") !== "true" || singleView)) {
      this.handleOpen();
      if (!singleView){
        localStorage.setItem("showNews", true);
      }
    }
  }

  componentWillUnmount() {
    this.handleClose();
    const { allNews: { selectedPreviewItems }, clearSelectedPreview } = this.props;
    if (selectedPreviewItems?.length && clearSelectedPreview) { clearSelectedPreview(); }
  }

  handleOpen = () => {
    this.setState({
      openPopup: true,
    });

  };

  handleClose = () => {
    this.setState({ openPopup: false });
  };

  closeLatestPopup = () => {
    this.setState({
      openPopup: false,
    });
  };

  navToLink(e, link) {
    e.stopPropagation();
    this.props.history.push(link);
    this.handleClose();
  }

  render() {
    const {
      classes,
      allNews: {
        latestItems,
        latestLoading,
        selectedPreviewItems,
      }
    } = this.props;

    let itemsToShow = selectedPreviewItems?.length ? selectedPreviewItems : latestItems;
    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            <Dialog className={classes.newsPopup} fullWidth onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={this.state.openPopup}>
              <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                <span class="">Latest News</span>

                <IconButton aria-label="close" className={classes.closeButton} onClick={this.handleClose}>
                  <CloseIcon />
                </IconButton>
                {!selectedPreviewItems?.length && <Button
                  className={classes.viewAll}
                  onClick={() => {
                    this.props.history.push("/all-news");
                    this.handleClose();
                  }}
                >
                  View all news
                </Button>}
              </DialogTitle>
              <DialogContent dividers>
                {itemsToShow.length > 0 && itemsToShow.map((item, index) => {
                  return (
                    <>
                      <li>
                        <h3>{item.title}</h3>
                        <p><span>{<Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>{item.startDate}</Moment>}</span> - <span>{<UserDisplay userId={item?.createdBy} showUserIdIfNot={true} />}</span> - {renderTextWithLinks(item.message)}</p>                      
                        {(item?.playlist?.name && item?.playlist?.plId) && (
                          <div>
                            Playlist: <Link
                              key={`link-playlist-${item.playlist.plId}`}
                              href="#"
                              onClick={(e) => this.navToLink(e, `/playlist/${item.playlist.plId}`, true)}
                            >
                              <strong class="tablesLink">
                                {item.playlist.name}
                              </strong>
                            </Link>
                          </div>
                        )}
                      </li>
                    </>
                  )
                })}
                {itemsToShow && !itemsToShow.length && !latestLoading && (
                  <div className={classes.noData}>
                    {t("tableView.noDataToPreview")}
                  </div>
                )}
                {itemsToShow && !itemsToShow.length && (latestLoading) && (
                  <CircularProgress
                    size={40}
                    className={classes.progressnew}
                  />
                )}
              </DialogContent>
            </Dialog>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  allNews: state.allNews,
  user: state.user,
});

export default connect(mapStateToProps, {
  searchLatest,
  clearSelectedPreview,
})(withStyles(styles)(withRouter(LatestNewsWrap)));